import React from 'react';
import PropTypes from 'prop-types';

import ComboBox, { IComboBox, IComboOption } from '../../molecules/combo-box/combo-box';

import './combo-box-index.scss';

export interface IComboBoxIndex extends IComboBox {}

const ComboBoxIndex: React.FC<IComboBoxIndex> = ({
  options,
  selected = '',
  placeholder,
  isLoading = false,
  isDisabled = false,
  onClickCallback = () => {},
}) => {
  return (
    <React.Fragment>
      <ComboBox
        options={options}
        selected={selected}
        isLoading={isLoading}
        isDisabled={Boolean(isDisabled)}
        placeholder={placeholder}
        onClickCallback={onClickCallback}
      />
    </React.Fragment>
  );
};

ComboBoxIndex.propTypes = {
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  options: PropTypes.arrayOf<IComboOption>(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    }).isRequired
  ).isRequired,
  placeholder: PropTypes.string.isRequired,
  selected: PropTypes.string,
};

export default ComboBoxIndex;
